import React from "react";
import PropTypes from "prop-types";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { dialogActionsSx, dialogPaperSx, dialogTitleSx } from "components/common/dialogStyles";

function AppFormDialog({
  open,
  onClose,
  title,
  maxWidth = "md",
  actions,
  contentSx,
  children,
  ...dialogProps
}) {
  const titleId = React.useId();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby={titleId}
      fullWidth
      maxWidth={maxWidth}
      PaperProps={{ sx: dialogPaperSx }}
      {...dialogProps}
    >
      <DialogTitle id={titleId} sx={dialogTitleSx}>
        {title}
      </DialogTitle>
      <DialogContent
        sx={{
          px: { xs: 2, sm: 3 },
          pt: "8px !important",
          pb: 3,
          overflowX: "auto",
          "& > .MuiPaper-root, & > .MuiContainer-root": {
            width: "100%",
            maxWidth: "none",
            minWidth: "0 !important",
            marginTop: "0 !important",
            padding: "0 !important",
            boxShadow: "none",
            backgroundColor: "transparent",
            border: 0,
          },
          "& > .MuiBox-root, & > form > .MuiBox-root": {
            minWidth: "0 !important",
            marginTop: "0 !important",
          },
          "& .MuiFormLabel-root": { fontSize: "0.95rem", fontWeight: 500 },
          "& .MuiOutlinedInput-root:not(.MuiInputBase-multiline)": { minHeight: 48 },
          "& .MuiInputBase-input": { fontSize: "1rem" },
          "& .MuiFormControl-root": { minWidth: 0, maxWidth: "100%" },
          "& .MuiFormHelperText-root": { fontSize: "0.8rem", lineHeight: 1.35, mt: 0.5 },
          "& .MuiAlert-root": { fontSize: "0.9rem" },
          ...contentSx,
        }}
      >
        {children}
      </DialogContent>
      {actions && (
        <DialogActions sx={{ ...dialogActionsSx, "& > button": { flex: 1, minWidth: 0 } }}>
          {actions}
        </DialogActions>
      )}
    </Dialog>
  );
}

AppFormDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  maxWidth: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
  actions: PropTypes.node,
  contentSx: PropTypes.object,
  children: PropTypes.node.isRequired,
};

export default AppFormDialog;
